module.exports = __webpack_public_path__ + "img/hsbc-gallery.b133d278.jpg";